import React from 'react'
import SbEditable from 'storyblok-react'
import Headline from '../atoms/Headline'
import LayeredTeaser from '../atoms/LayeredTeaser'

const DoubleTeaserBlock = ({ block }) => {
  return (
    <SbEditable content={block}>
      <section className="double-teaser-block related-products-block">
        <div className="double-teaser-block-container">
          <div className="double-teaser-block-wrapper">
            <div className="double-teaser-block-header">
              <Headline
                kicker={block.kicker}
                headline={block.headline}
                subheadline={block.subheadline}
              />
            </div>
            <div className="double-teaser-block-row justify-content-start">
              {block.teaser?.length > 0 &&
                block.teaser.map((item, index) => (
                  <LayeredTeaser item={item} key={index} />
                ))}
            </div>
          </div>
        </div>
      </section>
    </SbEditable>
  )
}

export default DoubleTeaserBlock
